import useAPI from '@api/useAPI';
import { useState, useRef } from 'react';
import { APICallProps } from '@types';

type TProps = {
	url: string;
	interval?: number;
	method?: 'GET' | 'POST' | 'PATCH' | 'DELETE',
	headers?: { [key: string]: string };
}

export const useLongPoll = (props: TProps) => {
	const {
		url,
		interval = 5000,
		method = 'GET',
		headers
	} = props;
	const [isPolling, setIsPolling] = useState(false);
	const {
		isLoading,
		data,
		error,
		clearData,
		clearError,
		callAPI
	} = useAPI({
		endpoint: url,
		method,
		headers
	});
	const poll = useRef<ReturnType<typeof setInterval>>();

	const startPolling = (props?: APICallProps) => {
		setIsPolling(true);
		poll.current = setInterval(() => {
			callAPI(props);
		}, interval);
	}

	const cancelPolling = () => {
		setIsPolling(false);
		clearInterval(poll.current);
	}

	return {
		isLoadingAPICall: isLoading,
		pollData: data,
		pollError: error,
		clearPollData: clearData,
		clearPollError: clearError,
		isPolling,
		startPolling,
		cancelPolling
	}
}
